import React from 'react';
import { Grid, Paper, Stack, Text, Title } from '@mantine/core';
import CommunityEventsCard from './community_events_card';
import CommunityPageCard from './community_page_card';
import ConversationCallsCard from './conversation_calls_card';

const CommunityPage = ({
  accentColor,
  title,
  description,
  conversationCalls = [],
  cards = [],
  eventsCardImageUrl,
  eventsCardTitle,
  eventsCardDescription,
  communityEvents = [],
  joinBlocked = false,
  joining = false,
  onJoinConversationCall,
  onConversationCallsRefresh,
}) => (
  <Paper bg='white' radius='lg' p='lg'>
    <Stack gap='md'>
      <Stack gap={4}>
        <Title order={1} size='h2'>{title}</Title>
        <Text c='dimmed' size='sm'>{description}</Text>
      </Stack>
      <Grid>
        {
          conversationCalls.length > 0 &&
            <Grid.Col span={12}>
              <ConversationCallsCard
                accentColor={accentColor}
                conversationCalls={conversationCalls}
                joinBlocked={joinBlocked}
                joining={joining}
                onJoin={onJoinConversationCall}
                onConversationCallsRefresh={onConversationCallsRefresh}
              />
            </Grid.Col>
        }
        {
          cards.map(card => (
            <Grid.Col
              key={card.primary_button_url || card.title}
              span={{base: 12, sm: 6}}
            >
              <CommunityPageCard {...card} />
            </Grid.Col>
          ))
        }
        <Grid.Col span={{base: 12, sm: 6}}>
          <CommunityEventsCard
            title={eventsCardTitle}
            description={eventsCardDescription}
            image_url={eventsCardImageUrl}
            events={communityEvents}
          />
        </Grid.Col>
      </Grid>
    </Stack>
  </Paper>
);

export default CommunityPage;
